import {Component, OnInit} from '@angular/core';
import {ModalDialogV3} from '../../../../shared-modal-dynamic/models/modal-dialog-v3';

@Component({
  selector: 'app-modal-agreement-not-confirmed-info',
  templateUrl: './modal-agreement-not-confirmed-info.component.html',
  styleUrl: './modal-agreement-not-confirmed-info.component.scss'
})
export class ModalAgreementNotConfirmedInfoComponent extends ModalDialogV3 {

    closeModal() {
        this.close();
    }
}

